import { Button, Form, InputGroup } from 'react-bootstrap';
import React, { useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import Signup from './signup';

const Login = (props) => {
	const [ userName, setUserName ] = useState('');
	const [ password, setPassword ] = useState('');
	const [ showType, setShowType ] = useState(false);

	let auth = JSON.parse(localStorage.getItem('auth'));

	// if (auth === null) {
	// 	// auth = [ { username: 'aaa', password: 'aaa' } ];
	// 	alert('No user found!');
	// 	// return <Signup />;
	// }

	// if (auth === null) {
	// 	alert('No user found..');
	// }

	const handleLogin = () => {
		if (auth === null) {
			alert('No user found..signup to be the first user!');
		}
		const filter = auth.filter((d) => d.username === userName);

		if (filter.length !== 0) {
			if (filter[0].password === password) {
				localStorage.setItem('userLoggedIn', userName);
				setUserName('');
				setPassword('');
				props.afterLogin(userName);
			} else {
				alert('Wrong password');
			}
		} else {
			alert('Signup first!');
		}
	};

	return (
		<Form style={{ padding: '5% 30% 5% 30%' }}>
			<h1>Login</h1>
			<Form.Group>
				<span style={{ margin: '5px' }} />
				<Form.Control
					type="text"
					value={userName}
					onChange={(e) => setUserName(e.target.value)}
					placeholder="Username"
				/>
			</Form.Group>
			<span style={{ margin: '5px' }} />
			<Form.Group>
				<InputGroup>
					<Form.Control
						placeholder="Password"
						type={showType ? 'text' : 'password'}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<Button
						variant="dark"
						onClick={() => {
							setShowType(!showType);
						}}
					>
						{showType ? <FaRegEye /> : <FaRegEyeSlash />}
					</Button>
				</InputGroup>
			</Form.Group>

			<span style={{ margin: '5px' }} />
			<Form.Group>
				{userName && password !== '' ? (
					<Button variant="success" onClick={handleLogin} active>
						Login
					</Button>
				) : (
					<Button variant="secondary" onClick={handleLogin} disabled>
						Login
					</Button>
				)}
			</Form.Group>
		</Form>
	);
};

export default Login;
